import { z } from 'zod';
import { notificationRuleBaseSchema } from '@/features/notification-rules/schemas/notification-rules.schema.ts';

const createNotificationRuleBaseSchema = notificationRuleBaseSchema
  .pick({
    notificationTitle: true,
    ruleType: true,

    deviceType: true,
    deviceId: true,
    deviceSN: true,

    conditions: true,

    notificationTemplate: true,
    notificationPreviewTemplate: true,

    cooldownPeriod: true,

    status: true,
  })
  .extend({
    plantId: z.string({ error: 'Plant name is required' }).min(1, 'Plant name is required'),

    managedBy: z.enum(['self-managed', 'company-managed']).optional().default('self-managed'),
  });

export const createNotificationRuleSchema = createNotificationRuleBaseSchema
  .refine(
    (data) => {
      if (data.ruleType === 'device') {
        return data.deviceType;
      }
      return true;
    },
    {
      message: 'Device type is required for device rules',
      path: ['deviceType'],
    }
  )
  .refine(
    (data) => {
      if (data.ruleType === 'device') {
        return data.deviceId;
      }
      return true;
    },
    {
      message: 'Device serial number is required for device rules',
      path: ['deviceId'],
    }
  );

export const basicInformationFormSchema = createNotificationRuleBaseSchema.pick({
  notificationTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,
});

export const conditionsFormSchema = createNotificationRuleBaseSchema.pick({
  notificationTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,
});

export const messageTemplateFormSchema = createNotificationRuleBaseSchema.pick({
  notificationTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,

  notificationTemplate: true,
  notificationPreviewTemplate: true,
});

export const otherOptionsFormSchema = createNotificationRuleBaseSchema.pick({
  notificationTitle: true,
  ruleType: true,

  plantId: true,
  deviceType: true,
  deviceId: true,
  deviceSN: true,

  conditions: true,

  notificationTemplate: true,
  notificationPreviewTemplate: true,

  cooldownPeriod: true,
});

export type NotificationRuleFormData = z.infer<typeof createNotificationRuleSchema>;
